export type Size = typeof sizes[number]
export type ThumbnailType = typeof thumbnailTypes[number]

export type MapSize = {
  [key in Size]: string
}

export const sizes = ['xs', 'sm', 'md', 'lg', 'xl'] as const
export const thumbnailTypes = ['profile', 'company'] as const
export const mapSizeToClass: MapSize = {
  xs: 'w-6 h-6',
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16'
}

export const mapSizeToMarginRight: MapSize = {
  xs: '-mr-2',
  sm: '-mr-3',
  md: '-mr-4',
  lg: '-mr-5',
  xl: '-mr-6'
}

export const mapSizeToFontSize: MapSize = {
  xs: '!text-body-bold-xs',
  sm: '!text-body-bold-s',
  md: '!text-body-bold-m',
  lg: '!text-body-bold-l',
  xl: '!text-body-bold-xl'
}
